import { call, put } from "redux-saga/effects";
import { createProspectFromDataVault, deleteSavedScrapperData, getIndustryList, getJobTitleList, getMobileAccess, getOrgSuggestion, getRecentSave, getRecentSearch, getSavedScrapperData, getScrapperData, saveScrapperData } from "../../../../Services/apiService";
import { deleteSavedScrapperFailure, deleteSavedScrapperSuccess, getIndustrySuggestionFailure, getIndustrySuggestionSuccess, getJobTitleSuggestionFailure, getJobTitleSuggestionSuccess, getMobileAccessFailure, getMobileAccessSuccess, getOrgSuggestionFailure, getOrgSuggestionSuccess, getRecentSaveFailure, getRecentSaveSuccess, getRecentSearchFailure, getRecentSearchSuccess, getSavedScrapperFailure, getSavedScrapperSuccess, getScrapperFailure, getScrapperSuccess, saveProspectFailure, saveProspectSuccess, saveScrapperFailure, saveScrapperSuccess } from "../../../Slices/scrapperSlice";

export function* getScrapperHandler(actions) {
    try {
        const response = yield call(getScrapperData, actions?.payload);
        yield put(getScrapperSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getScrapperFailure(errResponse));
    }
}

export function* getOrgSuggestionHandler(actions) {
    try {
        const response = yield call(getOrgSuggestion, actions?.payload);
        yield put(getOrgSuggestionSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getOrgSuggestionFailure(errResponse));
    }
}

export function* getMobileAccessHandler(actions) {
    try {
        const response = yield call(getMobileAccess, actions?.payload);
        yield put(getMobileAccessSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getMobileAccessFailure(errResponse));
    }
}

export function* saveScrapperDataHandler(actions) {
    try {
        const response = yield call(saveScrapperData, actions?.payload);
        yield put(saveScrapperSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(saveScrapperFailure(errResponse));
    }
}

export function* getSavedScrapperHandler(actions) {
    try {
        const response = yield call(getSavedScrapperData, actions?.payload);
        yield put(getSavedScrapperSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getSavedScrapperFailure(errResponse));
    }
}

export function* deleteSavedScrapperHandler(actions) {
    try {
        const response = yield call(deleteSavedScrapperData, actions?.payload);
        yield put(deleteSavedScrapperSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(deleteSavedScrapperFailure(errResponse));
    }
}

export function* savePropectHandler(actions) {
    try {
        const response = yield call(createProspectFromDataVault, actions?.payload);
        yield put(saveProspectSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(saveProspectFailure(errResponse));
    }
}

export function* getJobSuggestionHandler(actions) {
    try {
        const response = yield call(getJobTitleList, actions?.payload);
        yield put(getJobTitleSuggestionSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getJobTitleSuggestionFailure(errResponse));
    }
}

export function* getIndustrySuggestionHandler(actions) {
    try {
        const response = yield call(getIndustryList, actions?.payload);
        yield put(getIndustrySuggestionSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getIndustrySuggestionFailure(errResponse));
    }
}

export function* getRecentSaveHandler(actions) {
    try {
        const response = yield call(getRecentSave, actions?.payload);
        yield put(getRecentSaveSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getRecentSaveFailure(errResponse));
    }
}

export function* getRecentSearchHandler(actions) {
    try {
        const response = yield call(getRecentSearch, actions?.payload);
        yield put(getRecentSearchSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getRecentSearchFailure(errResponse));
    }
}